(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["product-template"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Get the metafield value from the data attribute
    var engraveOption = document.querySelector('.product-page').dataset.engraveOption;

    // Check if engrave option is true or false
    if (engraveOption === 'true') {
        // Show the custom input div
        document.querySelector('.custom-input').style.display = 'block';
    } else {
        // Hide the custom input div
        document.querySelector('.custom-input').style.display = 'none';
    }
});
  
  } catch(e) { console.error(e); }
})();
      })();
